export const RECOVERY_NOTICE = "If this email is eligible, we'll send instructions. If you still can't sign in, contact your administrator.";
export const RECOVERY_ERROR = 'Unable to send instructions right now. Please try again.';
export const AUTH_LINK_ERROR = 'This link expired or was already used. Request a new email.';

export function validRecoveryEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export async function requestAuthRecovery(client, kind, email) {
    try {
        const { data, error } = await client.functions.invoke('auth-recovery', {
            body: { action: 'request', kind, email: email.trim() },
        });
        if (error || !data?.ok) throw new Error();
    } catch (_) {
        throw new Error(RECOVERY_ERROR);
    }
}

export function takeAuthLink() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('auth_link')) return null;
    const token = url.searchParams.get('auth_link');
    url.searchParams.delete('auth_link');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    return token || '';
}

export async function exchangeAuthLink(client, token) {
    try {
        const { data, error } = await client.functions.invoke('auth-recovery', {
            body: { action: 'exchange', token },
        });
        if (error || !data?.ok || typeof data.tokenHash !== 'string' || !data.tokenHash
            || !['magiclink', 'recovery'].includes(data.type)
            || !['invite', 'recovery'].includes(data.purpose)) throw new Error();
        const { data: verified, error: verificationError } = await client.auth.verifyOtp({
            token_hash: data.tokenHash, type: data.type,
        });
        if (verificationError || !verified?.user || !verified?.session) throw new Error();
        return { user: verified.user, purpose: data.purpose };
    } catch (_) {
        throw new Error(AUTH_LINK_ERROR);
    }
}
